/**
 * @file: ChatSearchPanel.tsx
 *
 * Chat search in a panel — a `BottomPanel` with a centred title + close header
 * (matching the other inbox panels), over the embedded `ChatSearchView`. A
 * picked thread/contact is handed back via `onPick`; the host routes it.
 */

import { ChatSearchPick } from '@euler/app/flows/chat/lib/types';
import { BottomPanel } from '@euler/components/BottomPanel';
import { PaneHeader } from '@euler/components/PaneHeader';
import { FC, memo } from 'react';
import { View } from 'react-native';
import { ChatSearchView } from '../pages/search';

export const ChatSearchPanel: FC<{
  visible: boolean;
  onPick: (pick: ChatSearchPick) => void;
  onClose: () => void;
}> = memo(({ visible, onPick, onClose }) => (
  <BottomPanel visible={visible} onClose={onClose}>
    <View style={{ flex: 1 }}>
      <PaneHeader title="搜索" align="center" onClose={onClose} />
      <ChatSearchView embedded onPick={onPick} onCancel={onClose} />
    </View>
  </BottomPanel>
));
